import * as cheerio from "cheerio";

const apiUrl = process.env.NEXT_PUBLIC_API_URL;

export const fetchText = async <T>(url: string, init?: RequestInit): Promise<{ status: number, data: T }> => {
    return await fetch(url, init)
        .then(response => response.text().then(data => ({status: response.status, data: data as T})))
}

export const fetchJson = async <T>(url: string, init?: RequestInit): Promise<{ status: number, data: T }> => {
    return await fetch(url, init)
        .then(response => response.json().then(data => ({status: response.status, data: data as T})))
}

export const fetchHtml = async (url: string, init?: RequestInit): Promise<{
    status: number,
    html: cheerio.CheerioAPI
}> => {
    return await fetch(url, init)
        .then(response => response.text().then(html => ({status: response.status, html: cheerio.load(html)})))
}

export const fetchBlob = async (url: string, init?: RequestInit): Promise<{ status: number, data: Blob }> => {
    return await fetch(url, init)
        .then(response => response.blob().then(data => ({status: response.status, data})))
}

export const api = async <T>(path: string, init?: RequestInit): Promise<{ status: number, data: T }> => {
    return await fetchJson<T>(`${apiUrl}${path}`, init);
}

export const removeSchema = (url: string): string => {
    return url.replace(/^[a-zA-Z]+:\/\//, '');
}

export const ensureHttps = (url: string): string => {
    return `https://` + removeSchema(url);
};

export const hostname = (url: string): string => {
    return removeSchema(url).split('/')[0];
}

export const isValidDomain = (value: string) => {
    return /([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}/i.test(value);
}

export const favicon = (url: string, size: number = 32): string => {
    url = ensureHttps(hostname(url));

    return `https://t0.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=${url}&size=${size}`
}
